export const getConversoesArea = (state) => state.conversoesArea.lista
export const getIsCarregandoListaConversoesArea = (state) => state.conversoesArea.isCarregandoLista
